import React, { useEffect } from "react";
import { useParams } from "react-router-dom";

import axios from "axios";
import { Container, Row, Col } from "react-bootstrap";

import { banUserApi, myTokenApi } from "../../../../utility/api/apiList";

import useAxios from "../../../../hooks/useAxios";
import useFilter from "../../../../hooks/useFilter";
import { calculatePageSize } from "../../../../libs/pagingDetail";

import { showDangerAlert } from "../../../../redux/actions/alert/alertActions";

import scrollToTop from "../../../../libs/scrollToTop";

import LoadingComponent from "../../../../components/public/loading";
import GoBackButtonComponent from "../../../../components/public/goBackButton";
import PurchaseSwitchComponent from "../../../../components/public/purchase/switch/styledPurchaseSwitch";
import PaginationComponent from "../../../../components/public/pagination";

import { UserOrdersTableHead } from "../../../../components/private/user/userFinancialComponents/userFinancialListPersonalComponent/styledUserFinancialListPersonalComponent";
import { TokenListHeader, TokenListTable } from "./styledUserTokenDetailContainer";

export default function UserTokenDetailContainer() {
  let { id } = useParams();
  const { filterState, onChange } = useFilter();
  const pageSize = 20;
  const {
    data: tokenListInfoData,
    isLoaded: tokenListInfoIsLoaded,
    run: runGetTokenListInfo,
  } = useAxios({
    url: myTokenApi,
    params: {
      token_id: id,
      type: "info",
    },
  });

  const {
    data: tokenListData,
    isLoaded: tokenListIsLoaded,
    run: runGetTokenList,
  } = useAxios({
    url: myTokenApi,
    params: {
      token_id: id,
      type: "tokens",
      page_size: pageSize,
      page: filterState["page"] || 1,
    },
  });

  const resultsDetail = () => {
    if (tokenListData) {
      return tokenListData?.count !== 0 ? tokenListData?.results : null;
    } else {
      return null;
    }
  };

  useEffect(() => {
    document.title = "اطلاعات کد اشتراک ";
    scrollToTop();
  }, []);

  useEffect(() => {
    fetchData();
  }, [filterState["page"]]);

  const fetchData = () => {
    runGetTokenListInfo();
    runGetTokenList();
  };

  const handleBannedUser = (e) => {
    e.preventDefault();
    // TODO: Refactor axios with useAxios
    axios
      .post(`${banUserApi}${e.target.id}/`)
      .then(() => {
        fetchData();
      })
      .catch(() => {
        showDangerAlert("اتفاقی رخ داده است. لطفا بعدا دوباره امتحان کنید.");
      });
  };

  let element = null;
  if (!tokenListInfoIsLoaded && !tokenListIsLoaded) {
    element = <LoadingComponent />;
  } else if (tokenListInfoData && tokenListData) {
    element = (
      <>
        <TokenListHeader className="px-1 p-md-3">
          <h6 className="text-center mb-4">
            کد اشتراک <span className="text-primary">{tokenListInfoData[0].token}</span>
          </h6>
          <Row>
            <Col xs={2}>تعداد کل: {tokenListInfoData[0].count}</Col>
            <Col xs={2}>استفاده شده: {tokenListInfoData[0].count_used}</Col>
            <Col xs={2}>
              باقی مانده:{" "}
              {tokenListInfoData[0].count - tokenListInfoData[0].count_used}
            </Col>
            <Col xs={3}>
              شروع:
              <span className="d-inline">{tokenListInfoData[0].start_date}</span>
            </Col>
            <Col xs={3}>
              پایان:
              <span className="d-inline">{tokenListInfoData[0].end_date}</span>
            </Col>
          </Row>
        </TokenListHeader>

        {!resultsDetail() ? (
          <p className="text-center mt-5">جزئیاتی وجود ندارد.</p>
        ) : (
          <TokenListTable className="striped overflow-auto text-center w-100 mt-lg-4">
            <UserOrdersTableHead>
              <tr>
                <th className="p-2 px-5">ردیف</th>
                <th className="p-2">نام و نام‌خانوادگی</th>
                <th className="p-2">کد ملی</th>
                <th className="p-2">وضعیت</th>
              </tr>
            </UserOrdersTableHead>
            <tbody>
              {resultsDetail().map((item, index) => {
                if (Object.keys(resultsDetail).length === index + 1) {
                  return (
                    <tr key={index}>
                      <td className="p-2 px-5">{index + 1}</td>
                      <td>{item.name}</td>
                      <td>
                        <span
                          dir="ltr"
                          className="inline-div container-nid-token-detail"
                        >
                          {item.nid}
                        </span>
                      </td>
                      <td>
                        <div className="d-flex justify-content-center gap-2">
                          <span className="status d-none d-md-inline">فعال</span>
                          <span className="d-inline d-md-none status">
                            {item.active ? "فعال" : "غیر فعال"}
                          </span>
                          <PurchaseSwitchComponent
                            id={`${item.id}`}
                            onChange={handleBannedUser}
                            inputProps={{ "aria-label": "controlled" }}
                            checked={item.active && item.active}
                          />
                          <span className="status d-none d-md-inline">غیرفعال</span>
                        </div>
                      </td>
                    </tr>
                  );
                } else {
                  return (
                    <tr key={index}>
                      <td className="p-2 px-5">{index + 1}</td>
                      <td>{item.name}</td>
                      <td>
                        <span
                          dir="ltr"
                          className="inline-div container-nid-token-detail"
                        >
                          {item.nid}
                        </span>
                      </td>
                      <td>
                        <div className="d-flex justify-content-center gap-2">
                          <span className="status d-none d-md-inline">فعال</span>
                          <span className="d-inline d-md-none status">
                            {item.active ? "فعال" : "غیر فعال"}
                          </span>
                          <PurchaseSwitchComponent
                            id={`${item.id}`}
                            onChange={handleBannedUser}
                            inputProps={{ "aria-label": "controlled" }}
                            checked={item.active && item.active}
                          />
                          <span className="status d-none d-md-inline">غیرفعال</span>
                        </div>
                      </td>
                    </tr>
                  );
                }
              })}
            </tbody>
          </TokenListTable>
        )}

        {tokenListData.count > 5 && (
          <PaginationComponent
            pageNumber={calculatePageSize(tokenListData.count, pageSize)}
            currentPage={filterState["page"] || 1}
            handleChangePage={(_, value) => {
              onChange("page", value);
            }}
            className="mt-5"
            defaulPage={1}
          />
        )}
      </>
    );
  }

  return (
    <Container className="py-3 px-0 px-md-2">
      <GoBackButtonComponent />
      {element}
    </Container>
  );
}
